<template>
<v-app id="inspire">
  <v-navigation-drawer v-model="drawer" fixed app>
    <v-list dense>
      <v-list-tile @click="$_goMenu({name: 'Home'})">
        <v-list-tile-action>
          <v-icon>home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <!--
      <v-list-tile @click="$_goMenu({name: 'ChargerStatus'})">
        <v-list-tile-action>
          <v-icon>dashboard</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>충전 현황</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      -->

      <v-list-tile @click="$_goMenu({name: 'ChargerChart'})">
        <v-list-tile-action>
          <v-icon>insert_chart_outlined</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>충전 통계</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="isAdmin" @click="$_goMenu({name: 'ChargerReport'})">
        <v-list-tile-action>
          <v-icon>insert_chart_outlined</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>충전 통계(new-관리자)</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="$_goMenu({name: 'ReportMonthly', params:{kind: 'checker'}})">
        <v-list-tile-action>
          <!--<v-icon>calendar_today</v-icon>-->
          <v-icon>event_note</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>근태기록</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="$_goMenu({name: 'ReportMonthlyAttendance', params:{kind: 'checker'}})">
        <v-list-tile-action>
          <!--<v-icon>calendar_today</v-icon>-->
          <v-icon>event_note</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>출근부</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!--
      <v-list-tile @click="$_goMenu({name: 'ReportMonthly', params:{kind: 'place'}})">
        <v-list-tile-action>
          <v-icon>event_note</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>충전소점검기록</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      -->

      <v-list-tile @click="$_goMenu({name: 'ReportMonthly', params:{kind: 'charger'}})">
        <v-list-tile-action>
          <!--<v-icon>calendar_today</v-icon>-->
          <v-icon>event_note</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>충전기점검기록</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="email !== 'polykid@gmail.com'" @click="$_goMenu({name: 'ReportDownload'})">
        <v-list-tile-action>
          <!--<v-icon>calendar_today</v-icon>-->
          <v-icon>event_note</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>리포트 다운로드</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <!--
      <v-list-tile @click="$_goMenu({name: 'PlugReportList'})">
        <v-list-tile-action>
          <v-icon>assignment</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>충전 기록</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      -->

      <!--
      <v-list-tile @click="$_goMenu({name: 'ReportList'})">
        <v-list-tile-action>
          <v-icon>assignment</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>점검 기록</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      -->

      <template v-if="isAdmin">
        <!--
        <v-list-tile @click="$_goMenu({name: 'Assignment'})">
          <v-list-tile-action>
            <v-icon>link</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>구성 현황</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>
        -->

        <v-list-group sub-group no-action>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>구성</v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile @click="$_goMenu({name: 'PlaceAssign'})">
            <v-list-tile-action>
              <v-icon>link</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>구성 (점검자 - 충전소)</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$_goMenu({name: 'ChargerAssign'})">
            <v-list-tile-action>
              <v-icon>link</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>구성 (충전소 - 충전기)</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$_goMenu({name: 'PlugAssign'})">
            <v-list-tile-action>
              <v-icon>link</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>구성 (충전기 - 플러그)</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group sub-group no-action>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>리소스 관리</v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile @click="$_goMenu({name: 'CheckerList'})">
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>점검자 관리</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$_goMenu({name: 'PlaceList'})">
            <v-list-tile-action>
              <v-icon>place</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>충전소 관리</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$_goMenu({name: 'ChargerList'})">
            <v-list-tile-action>
              <v-icon>offline_bolt</v-icon>
              <!--<v-icon>el_station</v-icon>-->
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>충전기 관리</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$_goMenu({name: 'PlugList'})">
            <v-list-tile-action>
              <v-icon>power</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>플러그 관리</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="$_goMenu({name: 'DatabaseMigration'})">
            <v-list-tile-action>
              <v-icon color="primary">import_export</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>데이터 마이그레이션</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-divider></v-divider>
    </template>
    <template v-else-if="!isGuest">
      <v-list-tile @click="$_goMenu({name: 'CheckerList'})">
        <v-list-tile-action>
          <v-icon>person</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>점검자 관리</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>
    </template>

    <v-list-tile @click="$_goMenu({name: 'Profile'})">
      <v-list-tile-action>
        <v-icon>account_circle</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>내정보</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-show="!loginDialog" @click="$_logout()">
    <v-list-tile-action>
      <v-icon>logout</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>logout</v-list-tile-title>
    </v-list-tile-content>
    </v-list-tile>

    </v-list>
  </v-navigation-drawer>
  <v-toolbar color="indigo" dark fixed app>
    <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    <v-toolbar-title>{{title}}</v-toolbar-title>
  </v-toolbar>
  <v-content>
    <!-- v-container fluid fill-height -->
    <v-container fill-height fluid>
      <!--
      <v-layout justify-center align-center>
        <v-flex text-xs-center>
          <v-tooltip left>
            <v-btn slot="activator" :href="source" icon large target="_blank">
              <v-icon large>code</v-icon>
            </v-btn>
            <span>Source</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn slot="activator" icon large href="https://codepen.io/johnjleider/pen/rJdVMq" target="_blank">
              <v-icon large>mdi-codepen</v-icon>
            </v-btn>
            <span>Codepen</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      -->

      <router-view
        v-if="!loginDialog"
        v-on:snackbar="$_runSnackbar"
        v-on:title="$_setTitle"/>
    </v-container>
  </v-content>
  <!--
  <v-footer color="indigo" app>
    <span class="white--text">&copy; 2017</span>
  </v-footer>
  -->
  <v-snackbar
    v-model="snackbar.on"
    fixed
    bottom
    :timeout="snackbar.timeout">{{ snackbar.text }}
      <!--
          <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      -->
  </v-snackbar>
  <v-dialog v-model="loginDialog" persistent max-width="500px">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Login form</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form ref="loginForm">
          <v-text-field
            prepend-icon="email"
            ref="email"
            name="email"
            label="email"
            type="text"
            v-model="email"
            :rules="emailRules"
            :error-messages="emailErrorMessage"
            @input="emailErrorMessage = ''"
            autocomplete="username"
            required></v-text-field>
          <v-text-field
            prepend-icon="lock"
            ref="password"
            name="password"
            label="Password"
            type="password"
            v-model="password"
            :rules="passwordRules"
            :error-messages="passwordErrorMessage"
            @input="passwordErrorMessage = ''"
            autocomplete="current-password"
            required></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$_login()">Login</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-app>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

// const googleMapsClient = require('@google/maps').createClient({
//   key: 'AIzaSyDjSpgZDSkiZXnaEMQMgKEf9TIjjVThaME',
//   Promise: Promise
// });

export default {
  data: () => ({
    loading: false,
    title: 'PowerCheck',
    drawer: null,
    loginDialog: true,
    email: '',
    emailRules: [
      v => !!v || '이메일을 입력하세요.',
      v => /.+@.+/.test(v) || '이메일 형식이 아닙니다.'
    ],
    emailErrorMessage: '',
    password: '',
    passwordRules: [
      v => !!v || '비밀번호를 입력하세요.',
      v => (v && v.length >= 6) || '비밀번호는 6자 이상입니다.'
    ],
    passwordErrorMessage: '',
    snackbar: {
      on: false,
      text: '',
      timeout: 2000
    },
    authListener: null,
    isAdmin: this.$store ? this.$store.state.session.admin : false,
    isGuest: this.$store ? this.$store.state.session.guest : false
  }),
  props: {
    source: String
  },
  created () {
    // console.log('onAuthStateChanged', firebase.auth().onAuthStateChanged)

    this.authListener = firebase.auth()
      .onAuthStateChanged((user) => {
        if (user) {
          this.loginDialog = false
          // console.log('User is signed in', user)

          /*
          name = user.displayName;
          email = user.email;
          photoUrl = user.photoURL;
          emailVerified = user.emailVerified;
          uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                          // this value to authenticate with your backend server, if
                          // you have one. Use User.getToken() instead.
          */

          // email 인증이 안되어 있으면 거치도록
          if (!user.emailVerified) {
            /*
            firebase.auth().languageCode = 'ko';
            user.sendEmailVerification().then(() => {
              console.log('사용자 확인 메일 발송됨')
            }).catch((error) => {
              console.log('An error happened.', error)
            })
            */
          }

          // console.log(user.email)
          // TODO DB 에서 권한 설정 할 수 있도록 할 것
          // TODO 아래 권한에 의해 메뉴를 disable 시키지만 URL 을 통한 직접 접근을 막기 위해 각 메뉴 페이지에서도 권한 검사할 것
          if (user.email === 'team.davinci.dev@gmail.com' ||
            user.email === 'ceo@peoplecommunication.kr') {
            this.isAdmin = true
            this.$store.commit('setAdmin', true)
          } else if (user.email === 'polykid@gmail.com') { // 에이나인 게스트 계정
            this.isGuest = true
            this.$store.commit('setGuest', true)
          }
        } else {
          this.$router.push('/')
          this.loginDialog = true
          // console.log('No user is signed in.')
        }
      })

      /* api 에서 쿼리하지 말고 android 에서 직접 주소 보냄
      googleMapsClient.geocode({address: '1600 Amphitheatre Parkway, Mountain View, CA'})
      .asPromise()
      .then((response) => {
        console.log(response.json.results);
      })
      .catch((err) => {
        console.log(err);
      });
      */
  },
  methods: {
    $_goMenu (router) {
      this.$router.push({...router, query: {time: new Date().getTime()}})
      // this.$router.push({...router}) //, query: {time: new Date().getTime()}})
    },
    $_runSnackbar (text) {
      // console.log('_snackbar', text)
      this.snackbar.text = text
      this.snackbar.on = true
    },
    $_setTitle (text) {
      this.title = text
    },
    async $_logout () {
      this.password = ''
      this.emailErrorMessage = ''
      this.passwordErrorMessage = ''
      this.$refs.loginForm.resetValidation()

      try {
        await firebase.auth().signOut()
        // Sign-out successful.
        // this.$router.push('/')
        console.log('Sign-out successful.')
      } catch (error) {
        console.log('An error happened.')
        console.log(error)
      }
    },
    // https://firebase.google.com/docs/auth/web/password-auth?hl=ko
    // https://firebase.google.com/docs/auth/web/manage-users?hl=ko
    async $_login () {
      this.loading = true

      if (this.$refs.loginForm.validate()) {
        this.emailErrorMessage = ''
        this.passwordErrorMessage = ''
        this.$refs.loginForm.resetValidation()

        try {
          await firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          // console.log(result)
          // this.snackbar.text = '인증 성공'
          // this.snackbar.on = true
        } catch (error) {
          if (error.code === 'auth/invalid-email') {
            this.emailErrorMessage = '이메일을 다시 확인하세요.'
          } else if (error.code === 'auth/user-not-found') {
            this.emailErrorMessage = '등록된 사용자가 아닙니다.'
          } else if (error.code === 'auth/wrong-password') {
            this.passwordErrorMessage = '비밀번호를 다시 확인하세요.'
          } else {
            this.snackbar.text = '인증 실패 (' + error.code + ')'
            this.snackbar.on = true
          }
          console.log(error.code, error.message)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue